module.exports = __webpack_public_path__ + "static/media/018-boy-3.148ffe7f.svg";